import axios from './axiosConfig'

export const getAllLatest = async () => {
  const response = await axios.get('/latest')
  // console.log(response.data)
  return response.data
}

export const getAllHideLatest = async () => {
  const response = await axios.get('/latest/hide')
  // console.log(response.data)
  return response.data
}

export const restoreReport = async (id) => {
  const response = await axios.put(`/latest/hide/${id}`)
  return response.data
}

// export const getCinImageFromInsight = async (insightType) => {
//   const response = await axios.get(
//     `/insights/uniqueCin?insightType=${insightType}`
//   )
//   console.log('onlyimagecin:', response.data)
//   return response.data
// }

// export const getByCinInsight = async (cin, insightType) => {
//   const response = await axios.get(
//     `/insights/byCin?cin=${cin}&insightType=${insightType}`
//   )
//   console.log('only:', response.data)
//   return response.data
// }

export const getLatestById = async (id) => {
  const response = await axios.get(`/latest/${id}`)
  console.log('response at api', response.data)
  return response.data
}

export const createLatest = async (formData) => {
  const data = new FormData()

  // Required fields
  data.append('pdfPrice', formData.pdfPrice)
  data.append('fundingDetails', formData.fundingDetails)
  data.append('cin', formData.cin)
  data.append('companyName', formData.companyName)
  data.append('fundingDate', formData.fundingDate)

  // File uploads - Fixed: files are File objects, not arrays
  if (formData.companyLogo && formData.companyLogo[0]) {
    data.append('companyLogo', formData.companyLogo[0])
  }

  if (formData.pdfFile && formData.pdfFile[0]) {
    data.append('pdfFile', formData.pdfFile[0])
  }

  // for (let [key, value] of data.entries()) {
  //   console.log(`${key}:`, value)
  // }

  try {
    const response = await axios.post('/latest', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error creating insight:', error)
    throw error
  }
}

export const updateLatest = async (id, formData) => {
  const data = new FormData()

  data.append('pdfPrice', formData.pdfPrice || '')
  data.append('fundingDetails', formData.fundingDetails || '')
  data.append('cin', formData.cin || '')
  data.append('companyName', formData.companyName || '')
  data.append('fundingDate', formData.fundingDate || '')

  // File uploads - required for create
  if (formData.companyLogo && formData.companyLogo[0]) {
    data.append('companyLogo', formData.companyLogo[0])
  }

  if (formData.pdfFile && formData.pdfFile[0]) {
    data.append('pdfFile', formData.pdfFile[0])
  }
  // Log FormData contents for debugging
  // for (let [key, value] of data.entries()) {
  //   console.log(`${key}:`, value)
  // }

  try {
    const response = await axios.put(`/latest/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })

    return response.data
  } catch (error) {
    console.error('Error updating deal:', error)
    throw error
  }
}

export const deleteLatest = async (id, otp) => {
  try {
    const response = await axios.delete(`/latest/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    // console.log('Delete latest response:', response.data)
    return response.data
  } catch (error) {
    console.error('Error deleting latest:', error)
    throw error
  }
}

export const sendMail = async (id) => {
  try {
    const response = await axios.get(`/latest/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching latest:', error)
    throw error
  }
}
